export const CARDHOLDER_NAME = /^([a-z]+[,.]?[ ]?|[a-z]+['-]?)+$/;

// eslint-disable-next-line no-useless-escape
export const PHONE_NUMBER = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/;

export const CURRENCY_AMOUNT = /^(?=.*\d)\d*(?:\.\d{0,2})?$/;
